import styled from 'styled-components';
import palette from '@mlc/mlc-palette';

export const Disclaimer = styled.div`
	p {
		color: ${palette.mlcWhite};
		font-size: 14px;
		margin: 0;
	}
`;
